var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeContactLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.45 35.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7970e;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.65,0c-.25,0-.51,0-.76,0C2.79.51-1.73,7.9.63,14.61l9.61,20a1,1,0,0,0,1.82,0L20.91,14.2a10.83,10.83,0,0,0-5.22-13A11.17,11.17,0,0,0,10.65,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.72,
    cy: 11.02,
    r: 4.54
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeContactLocation);
export default __webpack_public_path__ + "static/media/home-contact-location.7730190fa5bd10fcd8f5c0dcbd3e973f.svg";
export { ForwardRef as ReactComponent };